export default {
  apply: 'Terapkan',
  clear: 'Hapus',
  search_results: 'Hasil Pencarian',
  check_all: 'Check all',
  uncheck_all: 'Uncheck all'
};